<template>
  <v-app id="inspire">
    <div class="wrap-service-plan-show">
      <!-- Header -->
      <div class="sr-pl-show-top-header">
        <v-layout class="wrap">
          <v-flex>
            <v-layout class="align-center justify-start">
              <span class="headline"
                >Commercial Subscription ID: {{ subscription.id }}</span
              >
              <v-tooltip
                v-if="!no_data.includes(subscription.status)"
                top
                :disabled="!['paused', 'pending'].includes(subscription.status)"
              >
                <template v-slot:activator="{ on }">
                  <div
                    v-on="on"
                    class="subscriptions-status-text ml-2 mr-1"
                    :style="`color: ${status_colors[subscription.status]}`"
                    style="display: inline-block;"
                  >
                    <span>{{ titleCase(subscription.status) }}</span>
                    <v-icon v-if="subscription.status === 'pending'" :color="status_colors[subscription.status]" class="ml-1" size="20px">schedule</v-icon>
                  </div>
                </template>
                <template v-if="subscription.status === 'paused'">
                  <div class="text-center">Pause</div>
                  <div v-if="!this.no_data.includes(subscription.pause_subscription_start_date) || !this.no_data.includes(subscription.pause_subscription_end_date)">
                    <span
                      v-if="!no_data.includes(subscription.pause_subscription_start_date)"
                      >{{ subscription.pause_subscription_start_date }}</span
                    >
                    <span v-else>No Start Date</span> -
                    <span
                      v-if="!no_data.includes(subscription.pause_subscription_end_date)"
                      >{{ subscription.pause_subscription_end_date }}</span
                    >
                    <span v-else>No End Date</span>
                  </div>
                </template>
                <template v-if="subscription.status === 'pending'">
                  <div style="maxWidth: 240px;">The client subscription is PENDING until the start date. If you have to assign field tech and service day to the client location right away, then please cancel PENDING subscription and create a new subscription with the start date on the present day or in the past.</div>
                </template>
              </v-tooltip>
              <v-tooltip
                v-if="
                  !no_data.includes(subscription.status) &&
                  subscription.status == 'active' &&
                  (!this.no_data.includes(subscription.pause_subscription_start_date) || !this.no_data.includes(subscription.pause_subscription_end_date))
                "
                top
              >
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="#FFA500" size="20px">
                    av_timer
                  </v-icon>
                </template>
                <div class="text-center">Scheduled Pause</div>
                <div>
                  <span
                    v-if="!this.no_data.includes(subscription.pause_subscription_start_date)"
                    >{{ subscription.pause_subscription_start_date }}</span
                  >
                  <span v-else>No Start Date</span> -
                  <span
                    v-if="!this.no_data.includes(subscription.pause_subscription_end_date)"
                    >{{ subscription.pause_subscription_end_date }}</span
                  >
                  <span v-else>No End Date</span>
                </div>
              </v-tooltip>
              <v-tooltip
                v-if="
                  !no_data.includes(subscription.status) &&
                  subscription.status == 'active' &&
                  !no_data.includes(subscription.end_date)
                "
                top
                class="mb-2"
              >
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="error" class="ml-1" size="20px"
                    >av_timer</v-icon
                  >
                </template>
                <div style="max-width: 300px;">
                  <div class="text-center">Scheduled End Date</div>
                  <div class="text-center">{{ subscription.end_date }}</div>
                </div>
              </v-tooltip>
            </v-layout>
          </v-flex>
          <v-spacer></v-spacer>
          <v-btn class="header-btn-back mx-0 mt-0" @click="$router.go(-1)">
            <v-icon class="header-btn-back-icon">navigate_before</v-icon>
            Back
          </v-btn>
        </v-layout>
        <p class="header-p" v-if="!loading">
          {{ subscription.commercial_client }} on {{ subscription.subscription_name }}
        </p>
        <v-layout class="wrap xs12 justify-end my-2">
          <v-spacer></v-spacer>
          <v-menu
            offset-y
            bottom
            left
            v-if="
              ['active', 'paused', 'pending'].includes(subscription.status) ||
                subscription.status == 'active' ||
                subscription.status == 'paused' ||
                subscription.status == 'pending' ||
                subscription.status == 'active' ||
                subscription.status == 'paused' ||
                (subscription.status !== 'paused' &&
                  subscription_paused.length > 0) ||
                subscription.status == 'active' ||
                subscription.status == 'paused'
            "
          >
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" color="primary" class="mr-0 ml-1 px-4">
                Actions <v-icon right>keyboard_arrow_down</v-icon>
              </v-btn>
            </template>
            <v-list style="cursor: pointer;">
              <v-list-item
                v-if="
                  subscription.status == 'active' ||
                    subscription.status == 'paused' ||
                    subscription.status == 'pending'
                "
                @click="vEmit({ name: 'CancelCommercialSubscription', data: subscription })"
              >
                <v-list-item-title
                  ><v-icon color="error" class="mr-2">highlight_off</v-icon>
                  Cancel Subscription</v-list-item-title
                >
              </v-list-item>
              <v-list-item
                v-if="subscription.status == 'active'"
                @click="vEmit({ name: 'PauseSubscription', data: subscription })"
              >
                <v-list-item-title
                  ><v-icon color="warning" class="mr-2"
                    >pause_circle_outline</v-icon
                  >
                  Pause Subscription</v-list-item-title
                >
              </v-list-item>
              <v-list-item
                v-if="subscription.status == 'paused'"
                @click="vEmit({ name: 'ContinueSubscription', data: subscription })"
              >
                <v-list-item-title
                  ><v-icon color="success" class="mr-2"
                    >play_circle_outline</v-icon
                  >
                  Continue Subscription</v-list-item-title
                >
              </v-list-item>
              <v-list-item
                v-if="
                  subscription.status !== 'paused' &&
                  (!this.no_data.includes(subscription.pause_subscription_start_date) || !this.no_data.includes(subscription.pause_subscription_end_date))
                "
                @click="cancelScheduledPause"
              >
                <v-list-item-title
                  ><v-icon color="success" class="mr-2">update</v-icon> Cancel
                  Scheduled Pause</v-list-item-title
                >
              </v-list-item>
              <v-list-item
                v-if="
                  ['active', 'paused', 'pending'].includes(
                    subscription.status
                  ) && no_data.includes(subscription.tip_amount)
                "
                @click="vEmit({ name: 'AddCommercialRecurringTip', data: subscription })"
              >
                <v-list-item-title
                  ><v-icon color="success" class="mr-2"
                    >add_circle_outline</v-icon
                  >
                  Add Recurring Tip</v-list-item-title
                >
              </v-list-item>
              <v-list-item
                v-if="
                  ['active', 'paused', 'pending'].includes(
                    subscription.status
                  ) && !no_data.includes(subscription.tip_amount)
                "
                @click="vEmit({ name: 'RemoveCommercialRecurringTip', data: subscription })"
              >
                <v-list-item-title
                  ><v-icon color="error" class="mr-2">highlight_off</v-icon>
                  Remove Recurring Tip</v-list-item-title
                >
              </v-list-item>
              <v-list-item
                v-if="
                  ['active', 'paused'].includes(subscription.status)
                "
                @click="vEmit({ name: 'ChangeCommercialSubscriptionPrice', data: subscription })"
              >
                <v-list-item-title
                  ><v-icon color="warning" class="mr-2">swap_horiz</v-icon>
                  Change Price</v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-menu>
        </v-layout>
      </div>
      <!-- Details Table -->
      <v-card class="sub-details-card-table">
        <v-data-table
          :headers="headers_details"
          :items="subscription_items"
          hide-default-footer
          class="elevation-1 sr-pl-sh-table details-table"
          colwidth-1="30px"
          :loading="loading"
          loader-height="2"
          mobile-breakpoint="100"
        >
          <template v-slot:item="{item}">
            <tr>
              <td>Commercial Client</td>
              <td>
                <v-layout
                  v-if="!no_data.includes(item.commercial_client)"
                  style="margin-left: -14px;"
                >
                  <v-menu bottom right d-inline-flex>
                    <template v-slot:activator="{ on }">
                      <v-btn class="ma-0" v-on="on" icon>
                        <v-icon color="#999">more_vert</v-icon>
                      </v-btn>
                    </template>
                    <v-list class="pa-0">
                      <v-list-item
                        @click="
                          $router.push(
                            `/commercial_client/${item.commercial_client_id
                            }/show?commercial_location_id=${item.commercial_location_id}`
                          )
                        "
                      >
                        <v-flex class="body-1">
                          <v-icon class="mr-2" color="primary" size="18px"
                            >visibility</v-icon
                          >
                          View Client Details
                        </v-flex>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-layout class="wrap align-center">
                    <v-flex>{{ item.commercial_client }}</v-flex>
                  </v-layout>
                </v-layout>
                <em v-else class="grey--text">No data</em>
              </td>
            </tr>
            <tr>
              <td>Location</td>
              <td>
                <span v-if="!no_data.includes(item.commercial_location)">{{item.commercial_location}}</span>
                <em v-else class="grey--text">No data</em>
              </td>
            </tr>
            <tr>
              <td>Client Email</td>
              <td>
                <span v-if="!no_data.includes(item.client_email)">{{
                  item.client_email
                }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
            </tr>
            <tr>
              <td>Subscription ID</td>
              <td>
                <span v-if="!no_data.includes(item.id)">{{
                  item.id
                }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
            </tr>
            <tr>
              <td>Subscription Name</td>
              <td>
                <span v-if="!no_data.includes(item.subscription_name)">
                  {{ item.subscription_name }}
                </span>
                <em v-else class="grey--text">No data</em>
              </td>
            </tr>
            <tr>
              <td>Date created</td>
              <td>
                <span v-if="!no_data.includes(item.created_at)">{{
                  item.created_at
                }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
            </tr>
            <tr>
              <td>Start Date</td>
              <td>
                <span v-if="!no_data.includes(item.start_date)">{{
                  item.start_date
                }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
            </tr>
            <tr v-if="!no_data.includes(item.canceled_at)">
              <td>Cancel Date</td>
              <td>
                <span>{{ item.canceled_at }}</span>
              </td>
            </tr>
            <tr>
              <td>End Date</td>
              <td>
                <span v-if="!no_data.includes(item.end_date)">{{
                  item.end_date
                }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
            </tr>
            <tr>
              <td>Amount</td>
              <td>
                <span v-if="!no_data.includes(item.price)"
                  >${{ parseFloat(item.price).toFixed(2)
                  }}<span
                    v-if="item.billing_interval"
                    class="sub-revenue-txt"
                  >
                    {{ item.billing_interval.replace(/_/g, " ") }}</span
                  ></span
                >
                <em v-else class="grey--text">No data</em>
              </td>
            </tr>
            <tr>
              <td>Tip</td>
              <td>
                <span v-if="!no_data.includes(item.tip_amount)">{{ 
                  `$${parseFloat(item.tip_amount).toFixed(2)}`
                }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
            </tr>
            <tr>
              <td>Billing Option</td>
              <td>
                <span v-if="!no_data.includes(item.category)">{{
                  categories.find(i => i.value === item.category).text
                }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
            </tr>
            <tr>
              <td>Billing Interval</td>
              <td>
                <span v-if="!no_data.includes(item.billing_interval)">{{
                  billingIntervals.find(
                    i => i.value === item.billing_interval
                  ).text
                }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
            </tr>
            <tr v-if="item.status === 'active'">
              <td>Start of Billing Period</td>
              <td>
                <span
                  v-if="!no_data.includes(item.current_period_start)"
                  >{{ formatDate(item.current_period_start) }}</span
                >
                <em v-else class="grey--text">No data</em>
              </td>
            </tr>
            <tr v-if="item.status === 'active' || item.status === 'paused'">
              <td>End of Billing Period</td>
              <td>
                <v-layout v-if="!no_data.includes(item.current_period_end)" style="margin-left: -2px;">
                  <v-tooltip
                    d-inline-flex
                    top
                    class="mb-2"
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        color="info"
                        size="21px"
                      >
                        info
                      </v-icon>
                    </template>
                    <div v-if="activeWithEndDate(item)" style="max-width: 220px;">
                      <template v-if="item.category === 'prepaid'">
                        Subscription will end on this date
                      </template>
                      <template v-if="item.category === 'cleanup'">
                        Next invoice will be created on this date if there are completed jobs (or if jobs completed).
                      </template>
                    </div>
                    <div v-else-if="billingIntervalDaily(item)" style="max-width: 220px;">
                      <template v-if="item.category === 'prepaid'">
                        Next invoice will be created on this date
                      </template>
                      <template v-if="item.category === 'cleanup'">
                        Next invoice will be created on this date if there are completed jobs (or if jobs completed)
                      </template>
                    </div>
                    <div v-else-if="activeWithScheduledPauseNoEndPause(item)" style="max-width: 220px;">
                      Next invoice will be created on this date.
                    </div>
                    <div v-else-if="activeWithScheduledPauseWithEndPause(item)" style="max-width: 220px;">
                      <template v-if="item.category === 'prepaid'">
                        Next invoice would be created on this date if scheduled pause was not in progress
                      </template>
                      <template v-if="item.category === 'cleanup'">
                        Next invoice would be created on this date if there are completed jobs, if scheduled pause was not in progress
                      </template>
                    </div>
                    <div v-else-if="pausedWithScheduledEndPause(item)" style="max-width: 220px;">Next invoice will be created on this date.</div>
                    <div v-else style="max-width: 220px;">Next invoice will be created on this date. It may change if the subscription is updated.</div>
                  </v-tooltip>
                  <v-flex class="pl-1">
                    <template
                      v-if="
                        (activeWithEndDate(item) && item.category === 'prepaid') ||
                        (item.status === 'canceled' && !no_data.includes(item.end_date))
                      "
                    >
                      {{ formatDate(item.end_date) }}
                    </template>
                    <template v-else>
                      {{ formatDate(item.current_period_end) }}
                    </template>
                  </v-flex>
                </v-layout>
                <em v-else class="grey--text">No data</em>
              </td>
            </tr>
            <tr>
              <td>Status</td>
              <td :style="`color: ${status_colors[item.status]}`">
                <v-tooltip
                  top
                  :disabled="item.status !== 'pending'"
                  class="mb-2"
                >
                  <template v-slot:activator="{ on }">
                    <v-layout
                      class="align-center subscriptions-status-text text-no-wrap"
                      style="display: inline-block"
                      v-on="on"
                    >
                      <span>{{ makeCapitalFirstLetter(item.status) }}</span>
                      <v-icon v-if="item.status === 'pending'" :color="status_colors[item.status]" class="ml-1" size="20px">schedule</v-icon>
                    </v-layout>
                  </template>
                  <div style="maxWidth: 240px;">The client subscription is PENDING until the start date. If you have to assign field tech and service day to the client location right away, then please cancel PENDING subscription and create a new subscription with the start date on the present day or in the past.</div>
                </v-tooltip>
                <v-tooltip
                  v-if="
                    item.status === 'active' && !no_data.includes(item.end_date)
                  "
                  top
                  class="mb-2"
                >
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" color="error" class="ml-1" size="20px"
                      >av_timer</v-icon
                    >
                  </template>
                  <div style="max-width: 300px;">
                    <div class="text-center">Scheduled End Date</div>
                    <div class="text-center">{{ item.end_date }}</div>
                  </div>
                </v-tooltip>
              </td>
            </tr>
            <tr v-if="item.status === 'canceled'">
              <td>Termination Reason</td>
              <td>
                <span v-if="!no_data.includes(item.termination_reason)">{{ item.termination_reason }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
            </tr>
            <tr v-if="item.status === 'canceled'">
              <td>Termination Comment</td>
              <td>
                <span v-if="!no_data.includes(item.termination_note)">{{ item.termination_note }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
            </tr>
            <template
              v-if="!no_data.includes(item.pause_subscription_start_date) && item.status === 'active'"
            >
              <tr>
                <td>
                  Pause Scheduled From Date
                </td>
                <td>
                  <template
                    v-if="
                      !no_data.includes(item.pause_subscription_start_date)
                    "
                  >
                    <v-icon
                      color="#FFA500"
                      size="19px"
                      class="mr-1"
                      style="vertical-align: middle;"
                    >
                      av_timer
                    </v-icon>
                    <span>{{ item.pause_subscription_start_date }}</span>
                  </template>
                  <em v-else class="grey--text">No data</em>
                </td>
              </tr>
              <tr>
                <td>
                  Pause Scheduled To Date
                </td>
                <td>
                  <template
                    v-if="
                      !no_data.includes(item.pause_subscription_end_date)
                    "
                  >
                    <v-icon
                      color="#FFA500"
                      size="19px"
                      class="mr-1"
                      style="vertical-align: middle;"
                    >
                      av_timer
                    </v-icon>
                    <span>{{ item.pause_subscription_end_date }}</span>
                  </template>
                  <em v-else class="grey--text">No data</em>
                </td>
              </tr>
              <tr
                v-if="!no_data.includes(item.pause_subscription_comment)"
              >
                <td>
                  Pause Comments
                </td>
                <td>
                  <span>{{ item.pause_subscription_comment }}</span>
                </td>
              </tr>
            </template>
            <template v-if="item.status === 'paused'">
              <tr>
                <td>Paused From Date</td>
                <td>
                  <span
                    v-if="!no_data.includes(item.pause_subscription_start_date)"
                    >{{ item.pause_subscription_start_date }}</span
                  >
                  <em v-else class="grey--text">No data</em>
                </td>
              </tr>
              <tr>
                <td>Paused To Date</td>
                <td>
                  <span
                    v-if="!no_data.includes(item.pause_subscription_end_date)"
                    >{{ item.pause_subscription_end_date }}</span
                  >
                  <em v-else class="grey--text">No data</em>
                </td>
              </tr>
              <tr
                v-if="!no_data.includes(item.pause_subscription_comment)"
              >
                <td>Pause Comments</td>
                <td>
                  <span>{{ item.pause_subscription_comment }}</span>
                </td>
              </tr>
            </template>
          </template>
        </v-data-table>
      </v-card>

      <cancel-subscription
        :terminationReasons="termination_reasonsOptions"
        @done="getSubscriptionDetails"
      ></cancel-subscription>

      <pause-subscription @done="getSubscriptionDetails"></pause-subscription>

      <continue-subscription
        @done="getSubscriptionDetails"
      ></continue-subscription>

      <add-recurring-tip @done="getSubscriptionDetails"></add-recurring-tip>

      <remove-recurring-tip @done="getSubscriptionDetails"></remove-recurring-tip>
    
      <change-price @done="getSubscriptionDetails"></change-price>
    </div>
  </v-app>
</template>

<script>
import ApiService from "@/common/api.service";
import _ from "lodash";
import CancelSubscription from "./CancelCommercialSubscription";
import PauseSubscription from "./PauseCommercialSubscription";
import ContinueSubscription from "./ContinueCommercialSubscription";
import AddRecurringTip from "./AddRecurringTip.vue"
import RemoveRecurringTip from "./RemoveRecurringTip.vue"
import ChangePrice from "@/components/Billing/CommercialSubscriptions/ChangeCommercialSubscriptionPrice"
import { mapGetters, mapActions } from 'vuex';

export default {
  name: "SubscriptionsShow",
  components: {
    CancelSubscription,
    PauseSubscription,
    ContinueSubscription,
    AddRecurringTip,
    RemoveRecurringTip,
    ChangePrice
  },
  data: () => ({
    no_data: [null, "", undefined, "null"],
    loading: true,
    current_frequency: "",
    subscription: {
      canceled_at: "",
      client_email: "",
      client_name: "",
      price: "",
      pricing_plan: "",
      service_plan: "",
      start_date: "",
      status: "",
      created_at: ""
    },
    headers_details: [
      { text: "Details", value: "details", sortable: false, width: "20%" },
      { sortable: false }
    ],
    categories: [
      { text: "Postpaid Fixed", value: "postpaid" },
      { text: "Prepaid Fixed", value: "prepaid" },
      { text: "Postpaid Per Cleanup", value: "cleanup" }
    ],
    billingIntervals: [
      { text: "Annually", value: "annually" },
      { text: "Semi-Annually", value: "semi-annually" },
      { text: "Every Four Months", value: "every_four_months" },
      { text: "Quarterly", value: "quarterly" },
      { text: "Every Two Months", value: "every_two_months" },
      { text: "Monthly", value: "monthly" },
      { text: "Every 4 Weeks", value: "4_weeks" },
      { text: "Bi-weekly", value: "bi-weekly" },
      { text: "Weekly", value: "weekly" },
      { text: "Daily", value: "daily" }
    ],
    subscription_items: [],
    termination_reasonsOptions: [],
    items: [],
    headers: [
      { text: "Status", value: "status" },
      { text: "Start Date", value: "start_date" },
      { text: "End Date", value: "end_date" },
      { text: "Subs. Name", value: "plan" },
      { text: "Email", value: "email" },
      { text: "Revenue", value: "price" },
      { text: "Actions", value: "actions", sortable: false, width: "120px" }
    ],
    subscription_id: "",
    subscription_paused: [],
    status_colors: {
      canceled: '#FF5252',
      active: '#4CAF50',
      paused: '#FFA500',
      pending: '#FFA500'
    }
  }),

  mounted() {
    this.getSubscriptionDetails();
  },
  methods: {
    ...mapActions(['vEmit']),
    getSubscriptionDetails(id = this.$route.params.id) {
      this.loading = true;

      ApiService.get("/commercial/subscription/show/" + id, { organization_id: this.user.organization_id}).then(response => {
        let data = response.data;
        this.subscription_items = [data.subscription];
        // this.subscription_id = data.subscription.id;
        this.subscription = data.subscription;
        // this.subscription_paused = data.subscription_paused;
        // this.current_frequency = data.subscription.frequency;
        this.loading = false;
        this.termination_reasonsOptions = data.termination_reasons;
      })
      .catch(error => {
        console.log(error)
        this.loading = false
      })
    },
    getIndex(array, key, value) {
      return array.findIndex(i => i[key] == value);
    },
    cancelScheduledPause() {
      this.vEmit({ 
        name: "ContinueSubscription", 
        data: {
          ...this.subscription,
          subscription_paused: [{
            start_date: this.subscription.pause_subscription_start_date,
            end_date: this.subscription.pause_subscription_end_date
          }]
        }
      });
    },
    changeSubscriptionModal(action) {
      this.vEmit({ name: "ChangeSubscription", data: { action, ...this.subscription } })
    },

    //Make a firts character capital of string from response
    makeCapitalFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    //Remove under score from string
    removeUnderScore(str) {
      for (let i in str) {
        str = str.replace("_", " ");
      }
      return (str = str.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }));
    },
    //Return under scores in string
    returnUnderScore(str) {
      for (let i in str) {
        str = str.replace(" ", "_");
      }
      return (str = str.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toLowerCase() + txt.substr(1).toLowerCase();
      }));
    },
    titleCase(str = "") {
      return _.startCase(str.replace(/_/g, " "));
    },
    activeWithEndDate (item) {
      return !this.no_data.includes(item) &&
      item.status === 'active' &&
      !this.no_data.includes(item.current_period_end) &&
      !this.no_data.includes(item.end_date) &&
      moment(item.end_date).isBefore(moment(item.current_period_end))
    },
    billingIntervalDaily (item) {
      return !this.no_data.includes(item) &&
      item.billing_interval === 'daily'
    },
    activeWithScheduledPauseNoEndPause (item) {
      return !this.no_data.includes(item) &&
      item.status === 'active' &&
      !this.no_data.includes(item.current_period_end) &&
      !this.no_data.includes(item.pause_subscription_start_date) &&
      this.no_data.includes(item.pause_subscription_end_date) &&
      moment(item.pause_subscription_start_date).isBefore(moment(item.current_period_end))
    },
    activeWithScheduledPauseWithEndPause (item) {
      return !this.no_data.includes(item) &&
      item.status === 'active' &&
      !this.no_data.includes(item.current_period_end) &&
      !this.no_data.includes(item.pause_subscription_start_date) &&
      !this.no_data.includes(item.pause_subscription_end_date) &&
      moment(item.current_period_end).isBetween(moment(item.pause_subscription_start_date), moment(item.pause_subscription_end_date))
    },
    pausedWithScheduledEndPause (item) {
      return !this.no_data.includes(item) &&
      item.status === 'paused' &&
      !this.no_data.includes(item.current_period_end) &&
      !this.no_data.includes(item.pause_subscription_end_date) &&
      moment(item.pause_subscription_end_date).isBefore(moment(item.current_period_end))
    },
    formatDate (date) {
      return moment(date).format("YYYY[-]MM[-]DD")
    }
  },
  computed: {
    ...mapGetters(['user'])
  }
};
</script>

<style>
/*Header*/
.wrap-service-plan-show .header-p {
  font-size: small;
}

.wrap-service-plan-show .header-p:first-of-type {
  font-size: medium;
  margin-bottom: 0px;
}

.wrap-service-plan-show .header-inv-num {
  display: inline-block;
  color: dimgrey;
}

.wrap-service-plan-show .header-btn-back {
  float: right;
  box-shadow: none !important;
  background-color: #f8f9fa !important;
  text-transform: none;
  font-weight: 400;
}

.wrap-service-plan-show .header-btn-back:focus {
  outline: none;
}

.wrap-service-plan-show .header-btn-back-icon {
  margin: 2px -5px 0px 0px;
}

.sub-action-btns {
  float: right;
  font-weight: 300;
}

.sub-action-btn-cancel {
  background-color: indianred !important;
  color: white !important;
}

.sub-action-btn-pause {
  background-color: orange !important;
  color: white !important;
}

.sub-action-btn-continue {
  background-color: forestgreen !important;
  color: white !important;
}

.sub-action-btn-change {
  border: solid 1px forestgreen !important;
}

.sub-action-btn-change .v-btn__content {
  color: forestgreen !important;
}

.subscriptions-type-canceled {
  color: red;
}

.subscriptions-type-active {
  color: forestgreen;
}

.subscriptions-type-paused {
  color: orange;
}

.subscriptions-type-pending {
  color: #2196f3;
}

.subscriptions-status-text {
  text-transform: uppercase;
}

.subscriptions-status-text span {
  font-size: 13px;
}

.sub-revenue-txt {
  font-size: 11px;
}

/* Make DIV sections to look like table rows */
.inv-desc-table-style {
  background-color: white;
  box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 1px 3px 0 rgba(0, 0, 0, 0.12) !important;
}

.table-header-div {
  background-color: darkgray !important;
  color: white;
  padding: 18px;
  height: 60px;
}

.table-header-div p {
  margin: 0px;
}

.sub-type-draft {
  color: red;
  min-width: 200px;
}

.sub-type-paid {
  color: forestgreen;
}

.sub-type-send {
  color: cornflowerblue;
}
</style>
